import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useAuth } from 'hooks'
import { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { SelectColaboradores } from 'templates/Avaliacao/atoms/forms/SelectColaboradores'

interface IProps {
    faixaAtual: number
}

export function EditarClienteForm({ faixaAtual }: IProps) {
    const ref = useRef<HTMLDivElement>(null)
    const { watch } = useFormContext()
    const {
        decoded: { categoria },
    } = useAuth()

    const [categoriaId, limiteFuncionarios] = watch([
        'categoriaId',
        'limiteFuncionarios',
    ])
    const criandoRepresentante = categoriaId === 7,
        faixaAlterada = limiteFuncionarios !== faixaAtual

    useEffect(() => {
        if (faixaAlterada) ref.current?.scrollIntoView({ behavior: 'smooth' })
    }, [faixaAlterada])

    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <FormField name="nomeFantasia" label="Nome da empresa" />
            </Grid>
            <Grid item xs={12}>
                <FormField name="razaoSocial" label="Razão social" />
            </Grid>
            <Grid item sm={4} xs={12}>
                <FormField
                    name="cnpj"
                    label="CNPJ"
                    options={{
                        blocks: [2, 3, 3, 4, 2],
                        delimiters: ['.', '.', '/', '-'],
                    }}
                />
            </Grid>
            <Grid item sm={8} xs={12}>
                <FormField name="nomeResponsavel" label="Nome do responsável" />
            </Grid>
            <Grid item sm={8} xs={12}>
                <FormField name="emailResponsavel" label="Email" />
            </Grid>
            <Grid item sm={4} xs={12}>
                <FormField
                    name="telefoneResponsavel"
                    label="Telefone (com DDD)"
                    options={{
                        phone: true,
                        phoneRegionCode: 'BR',
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <SelectColaboradores disabled={criandoRepresentante} />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="dtFimAtivacao"
                    label="Data final da ativação"
                    type="date"
                    disabled={categoria !== 1}
                />
            </Grid>
            {categoria === 1 ? (
                <Grid item xs={12}>
                    <FormFieldCheckbox
                        name="suporteIntegrado"
                        label="Suporte integrado"
                    />
                </Grid>
            ) : null}
            {faixaAlterada && (
                <Grid
                    item
                    xs={12}
                    ref={ref}
                    className="inline-flex items-center mb-4"
                >
                    <FormFieldCheckbox
                        name="alterarPlano"
                        label="Alterar plano do cliente"
                    />
                    <IconeAjuda>
                        Selecione essa opção caso deseje alterar o plano do
                        cliente para a faixa de colaboradores selecionada.
                        <br />
                        <br />A periodicidade do plano não será alterada, caso
                        deseje alterar a periodicidade, será necessário fazer
                        login com o usuário do cliente e alterar o plano
                        diretamente no painel do cliente.
                        <br />
                        <br />O método de pagamento utilizado será boleto.
                    </IconeAjuda>
                </Grid>
            )}
        </Grid>
    )
}
